import request from "@/utils/request";

export async function create() {
  const response = await request.post("/shopping-carts");
  return response.data.data;
}

export async function update(id, data) {
  const response = await request.put(`/shopping-carts/${id}`, data);
  return response.data.data;
}

export async function getById(id) {
  const response = await request.get(`/shopping-carts/${id}`);
  return response.data.data;
}